module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/big_image@2x.a17ee50.jpg";